/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetProfileSettingsInfo: BridgeCommands.Command<
    Types.Nvapp.Nvcplplugin.GetProfileSettingsInfoParameters,
    Types.Nvapp.Nvcplplugin.ProfileSettingsInfo
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'GetProfileSettingsInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetProfileInfo: BridgeCommands.Command<
    Types.Nvapp.Nvcplplugin.GetProfileInfoParameters,
    Types.Nvapp.Nvcplplugin.GetProfileInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'GetProfileInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetProfileSettingValue: BridgeCommands.Command<
    Types.Nvapp.Nvcplplugin.GetProfileSettingValueParameters,
    Types.Nvapp.Nvcplplugin.GetProfileSettingValueReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'GetProfileSettingValue',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetProfileSettingDefaultValue: BridgeCommands.Command<
    Types.Nvapp.Nvcplplugin.GetProfileSettingDefaultValueParameters,
    Types.Nvapp.Nvcplplugin.GetProfileSettingDefaultValueReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'GetProfileSettingDefaultValue',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetProfileNameFromExe: BridgeCommands.Command<
    Types.Nvapp.Nvcplplugin.GetProfileNameFromExeParameters,
    Types.Nvapp.Nvcplplugin.GetProfileNameFromExeReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'GetProfileNameFromExe',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetProfileSettingValue: BridgeCommands.Command<
    Types.Nvapp.Nvcplplugin.SetProfileSettingValueParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'SetProfileSettingValue',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ApplyProfileSettings: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'ApplyProfileSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetProfileJsonStringSettingPossibleValues: BridgeCommands.Command<
    Types.Nvapp.Nvcplplugin.GetProfileJsonStringSettingPossibleValuesParameters,
    Types.Nvapp.Nvcplplugin.GetProfileJsonStringSettingPossibleValuesReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'GetProfileJsonStringSettingPossibleValues',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetProfileStringSettingPossibleValues: BridgeCommands.Command<
    Types.Nvapp.Nvcplplugin.GetProfileStringSettingPossibleValuesParameters,
    Types.Nvapp.Nvcplplugin.GetProfileStringSettingPossibleValuesReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'GetProfileStringSettingPossibleValues',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetProfileScalarSettingPossibleValues: BridgeCommands.Command<
    Types.Nvapp.Nvcplplugin.GetProfileScalarSettingPossibleValuesParameters,
    Types.Nvapp.Nvcplplugin.GetProfileScalarSettingPossibleValuesReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'GetProfileScalarSettingPossibleValues',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RestoreDefaultForProfile: BridgeCommands.Command<
    Types.Nvapp.Nvcplplugin.RestoreDefaultForProfileParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'RestoreDefaultForProfile',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RestoreDefaultForAllProfiles: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'RestoreDefaultForAllProfiles',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ClearShaderCache: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'ClearShaderCache',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RunPreCompileShaderTool: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'RunPreCompileShaderTool',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StopPreCompileShaderTool: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'StopPreCompileShaderTool',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetShaderCompilerTaskLastRunTime: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcplplugin.GetShaderCompilerTaskLastRunTimeReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'GetShaderCompilerTaskLastRunTime',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetProgramProfileNames: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcplplugin.GetProgramProfileNamesReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'GetProgramProfileNames',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetProfilesAndApplicationsInfo: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcplplugin.GetProfilesAndApplicationsInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'GetProfilesAndApplicationsInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGlobalProfileNames: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcplplugin.GetGlobalProfileNamesReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'GetGlobalProfileNames',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CreateNewProfile: BridgeCommands.Command<
    Types.Nvapp.Nvcplplugin.CreateNewProfileParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'CreateNewProfile',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const DeleteProfile: BridgeCommands.Command<
    Types.Nvapp.Nvcplplugin.DeleteProfileParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'DeleteProfile',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDynamicBoost: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcplplugin.GetDynamicBoostReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'GetDynamicBoost',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGpuActivityTrayIconState: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcplplugin.GpuActivityTrayIconState
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'GetGpuActivityTrayIconState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ToggleGpuActivityTrayIcon: BridgeCommands.Command<
    Types.Nvapp.Nvcplplugin.ToggleGpuActivityTrayIconParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'ToggleGpuActivityTrayIcon',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CheckPrecompilationStatus: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'CheckPrecompilationStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const PrecompilationStatusNotification: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvcplplugin.PrecompilationStatusNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvCplPlugin',
    method: 'PrecompilationStatusNotification',
    persistent: true
};

export const Nvcplplugin = {
GetProfileSettingsInfo,
GetProfileInfo,
GetProfileSettingValue,
GetProfileSettingDefaultValue,
GetProfileNameFromExe,
SetProfileSettingValue,
ApplyProfileSettings,
GetProfileJsonStringSettingPossibleValues,
GetProfileStringSettingPossibleValues,
GetProfileScalarSettingPossibleValues,
RestoreDefaultForProfile,
RestoreDefaultForAllProfiles,
ClearShaderCache,
RunPreCompileShaderTool,
StopPreCompileShaderTool,
GetShaderCompilerTaskLastRunTime,
GetProgramProfileNames,
GetProfilesAndApplicationsInfo,
GetGlobalProfileNames,
CreateNewProfile,
DeleteProfile,
GetDynamicBoost,
GetGpuActivityTrayIconState,
ToggleGpuActivityTrayIcon,
CheckPrecompilationStatus,
PrecompilationStatusNotification
};
